import axios from 'axios'
import { getToken, AUTH_USER_TOKEN_KEY } from '../utils/auth.utils'
import { HttpClient } from './http.client'

export const env = process.env.REACT_APP_ENV
const apiUrl = process.env.REACT_APP_API_ENDPOINT

const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY!,
  },
})

// Add request interceptor to dynamically set authorization header on each request
axiosInstance.interceptors.request.use((config) => {
  const token = getToken()
  if (token) {
    config.headers.authorization = token
  }
  return config
})

// Add response interceptor to handle 401 unauthorized errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear invalid session
      localStorage.removeItem(AUTH_USER_TOKEN_KEY)
      // Redirect to login page
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export const client = () => new HttpClient(axiosInstance)
